import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import spIcon from "../../assets/brand/swlogo.png";
import spWordmark from "../../assets/brand/swletters.png";
import api from "../../api/api";
import { toast } from "react-toastify";

export const ProductPayment = () => {
  const [category, setCategory] = useState("");          
  const [shipping, setShipping] = useState("");        
  const [bankName, setBankName] = useState("");
  const [bankAccount, setBankAccount] = useState("");
  const [feePayment, setFeePayment] = useState("");
  const [saving, setSaving] = useState(false);

  const navigate = useNavigate();

  // If feePayment should be required, include it in the array & check.
  const isComplete = useMemo(
    () =>
      [category, shipping, bankName, bankAccount , feePayment].every(
        (v) => String(v).trim().length > 0
      ),
    [category, shipping, bankName, bankAccount , feePayment]
  );

  const handleNext = async (e) => {
    e.preventDefault();
    if (!isComplete) return;
    try {
      setSaving(true);
      await api.onboarding.saveProductPayment({ category, shipping, bankName, bankAccount, feePayment });
      navigate("/onboarding/security");
    } catch (e2) {
      toast.warn(e2?.data?.message || e2.message || "Failed to save");
    } finally { setSaving(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#fff8e1]">
      <div className="w-[412px] [font-family:'Nunito',Helvetica] text-[#5d4037]">

        <div className="w-full flex justify-center">
          <div className="inline-flex items-center gap-[0px] leading-none">
            <img
              src={spIcon}
              alt="Sweet Plate logo"
              className="shrink-0 select-none object-contain w-[65px] h-[86px] -mt-[2px]"
            />
            <img
              src={spWordmark}
              alt="Sweet Plate"
              className="shrink-0 select-none object-contain h-[29px] w-auto -ml-[4px]"
            />
          </div>
        </div>

        {/* Title */}
        <h1 className="mt-3 ml-6 font-bold text-[22px] leading-7">Join Sweet Plate Vendor</h1>

        <div className="w-[378px] mx-auto mt-3 flex items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-[#5d4037] text-[#fff8e1] grid place-items-center text-sm font-bold">1</div>
          <div className="flex-1 h-[2px] bg-[#5d4037]" />
          <div className="w-8 h-8 rounded-full bg-[#5d4037] text-[#fff8e1] grid place-items-center text-sm font-bold">2</div>
          <div className="flex-1 h-[2px] bg-[#5d4037]" />
          <div className="w-8 h-8 rounded-full bg-[#5d4037] text-[#fff8e1] grid place-items-center text-sm font-bold">3</div>
          <div className="flex-1 h-[2px] bg-[#5d4037]/40" />
          <div className="w-8 h-8 rounded-full border border-[#5d4037] grid place-items-center text-sm font-bold">4</div>
        </div>

        {/* Section header */}
        <div className="w-[378px] mx-auto mt-6">
          <p className="font-extrabold uppercase text-[14px] tracking-wide">Product & Payment</p>
          <p className="mt-1 text-[14px]">
            Provide the basic information to get your business
            registered with us.
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleNext} className="mt-4">
     
          <div className="w-[378px] mx-auto mt-3">
            <label className="block text-base font-semibold mb-2">Product Categories</label>
            <div className="relative">
              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                className="appearance-none w-full h-[56px] bg-[#fff8e1] rounded-[18px] border border-[#5d4037] pl-[17px] pr-10 text-[#7a6f5c] text-base outline-none"
              >
                <option value="">Food &amp; Drinks</option>
                <option value="Food & Drinks">Food &amp; Drinks</option>
                <option value="Grocery">Grocery</option>
                <option value="Bakery">Bakery</option>
                <option value="Catering">Catering</option>
              </select>
              <div className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24">
                  <path d="M6 9l6 6 6-6" />
                </svg>
              </div>
            </div>
          </div>

          <div className="w-[378px] mx-auto mt-5">
            <label className="block text-base font-semibold mb-2">Shipping Capabilities</label>
            <div className="relative">
              <select
                value={shipping}
                onChange={(e) => setShipping(e.target.value)}
                className="appearance-none w-full h-[56px] bg-[#fff8e1] rounded-[18px] border border-[#5d4037] pl-[17px] pr-10 text-[#7a6f5c] text-base outline-none"
              >
                <option value="">Domestic</option>
                <option value="Domestic">Domestic</option>
                <option value="Local Pickup">Local Pickup</option>
                <option value="International">International</option>
              </select>
              <div className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24">
                  <path d="M6 9l6 6 6-6" />
                </svg>
              </div>
            </div>
          </div>


          <div className="w-[378px] mx-auto mt-6">
            <p className="block text-base font-semibold">Payment Details</p>
          </div>


          <div className="w-[378px] mx-auto mt-3">
            <input
              type="text"
              placeholder="Bank Name"
              value={bankName}
              onChange={(e) => setBankName(e.target.value)}
              className="w-full h-[56px] bg-[#fff8e1] rounded-[18px] border border-[#5d4037] px-[17px] text-[#7a6f5c] text-base outline-none"
            />
          </div>

          <div className="w-[378px] mx-auto mt-4">
            <input
              type="text"
              inputMode="numeric"
              placeholder="Bank Account Number"
              value={bankAccount}
              onChange={(e) => setBankAccount(e.target.value)}
              className="w-full h-[56px] bg-[#fff8e1] rounded-[18px] border border-[#5d4037] px-[17px] text-[#7a6f5c] text-base outline-none"
            />
          </div>

         
          <div className="w-[378px] mx-auto mt-6">
            <p className="font-extrabold uppercase text-[14px] tracking-wide">Vendor Fee</p>
            <p className="mt-1 text-[14px]">Vendor pays 20% of every purchase on the app</p>
          </div>

          {/* Fee payment */}
          <div className="w-[378px] mx-auto mt-4">
            <label className="block text-base font-semibold mb-2">Fee payment</label>
            <div className="relative">
              <select
                value={feePayment}
                onChange={(e) => setFeePayment(e.target.value)}
                className="appearance-none w-full h-[56px] bg-[#fff8e1] rounded-[18px] border border-[#5d4037] pl-[17px] pr-10 text-[#7a6f5c] text-base outline-none"
              >
                <option value="">Pay after delivery</option>
                <option value="Pay after delivery">Pay after delivery</option>
                <option value="Pay upfront">Pay upfront</option>
              </select>
              <div className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24">
                  <path d="M6 9l6 6 6-6" />
                </svg>
              </div>
            </div>
          </div>
    
          <div className="w-[378px] mx-auto">
            <button
              type="submit"
              disabled={saving || !isComplete}
              className={`mt-7 mx-auto block w-[290px] h-[60px] rounded-[50px] bg-[#f7c945] font-bold text-[#5d4037] text-base leading-[22px] transition-opacity ${
                isComplete ? "hover:opacity-90" : "opacity-50 cursor-not-allowed pointer-events-none"
              }`}
            >
              Next
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
